module.exports = __webpack_public_path__ + "resource/static/img/icon9@1.5x.2f314e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img1/icon9@1.5x.png
// module id = GAVS
// module chunks = 1